export default class Message {

  static CHANNEL_DEALER_CUSTOMER = 1;
  static CHANNEL_SUPPORT_DEALER = 2;
  static CHANNEL_SUPPORT_DEALER_CUSTOMER = 3;
  static CHANNEL_SCHEDULER_CUSTOMER = 4;
  static CHANNEL_SCHEDULER_NOTARY = 5;
  static CHANNEL_NOTARY_CUSTOMER = 6;
  static CHANNEL_MY_NOTES = 7;
  static CHANNEL_INTERNAL_NOTES = 8;
  static CHANNEL_SCHEDULER_DEALER = 9;
  static CHANNEL_DEALER_SCHEDULER_NOTARY = 10;

  static CHANNEL_MEMBER_TYPE_USER = 1;
  static CHANNEL_MEMBER_TYPE_SIGNER = 2;

  static CONTENT_TYPE_TEXT = 1
  static CONTENT_TYPE_IMAGE = 2

  // in order to extend the current channels with a new channel
  // we need to add it to the getChannelMap method
  // and edit the permissions for it in the src/context/access.js file
  static getChannelMap() {
    return {
      [this.CHANNEL_DEALER_CUSTOMER]: 'Dealer - Customer',
      [this.CHANNEL_SUPPORT_DEALER]: 'Tech Support - Dealer',
      [this.CHANNEL_SUPPORT_DEALER_CUSTOMER]: 'Tech Support - Dealer - Customer',
      [this.CHANNEL_SCHEDULER_DEALER]: 'Scheduler - Dealer',
      [this.CHANNEL_DEALER_SCHEDULER_NOTARY]: 'Dealer - Scheduler - Notary',
    };
  }

  static getChannelName(id) {
    return this.getChannelMap()[id];
  }

  static getDealerChannelMap() {
    return {
      [this.CHANNEL_DEALER_CUSTOMER]: 'Dealer - Customer',
      [this.CHANNEL_SCHEDULER_DEALER]: 'Scheduler - Dealer',
      [this.CHANNEL_DEALER_SCHEDULER_NOTARY]: 'Dealer - Scheduler - Notary',
    };
  }

  static getTechChannelMap() {
    return {
      [this.CHANNEL_SUPPORT_DEALER]: 'Tech Support - Dealer',
      [this.CHANNEL_SUPPORT_DEALER_CUSTOMER]: 'Tech Support - Dealer - Customer',
    };
  }

  static getInStoreChannelMap() {
    return {
      [this.CHANNEL_SUPPORT_DEALER]: 'Tech Support - Dealer',
    };
  }
}